import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Card, Nav, Alert, Spinner, Badge } from 'react-bootstrap';
import { FaExclamation, FaExclamationCircle, FaExclamationTriangle, FaStopCircle } from 'react-icons/fa';
import Select from 'react-select';

const EntrerModal = ({ show, onHide, onSave, typeParc, parcRef }) => {

    const user_id = localStorage.getItem("userId");
    const [userData, setUserData] = useState({});

    const fetchUserData = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`);
            if (!response.ok) throw new Error('Erreur réseau');
            const data = await response.json();
            console.log(data)
            setUserData(data);
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const [parametres, setParametres] = useState({
        typeCamionTwistlock: [],
    });

    // Fonction pour récupérer les paramètres depuis le back-end
    const recupererParametres = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/info-parametres-notifications/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();

            if (response.ok) {
                setParametres({
                    typeCamionTwistlock: data.data.type_camion_twistlock || [],
                });

                console.log("typeCamionTwistlock : ", data.data.type_camion_twistlock)
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const [types, setTypes] = useState([]);
    const fetchTypes = async () => {
        try {
            const response = await fetch(
                process.env.REACT_APP_HOTE + "/liste-types/"
            );
            if (response.ok) {
                const data = await response.json();
                setTypes(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des types:", error);
        }
    };


    useEffect(() => {
        fetchUserData();
        recupererParametres();
        fetchTypes();
    }, [user_id]);


    // États pour la gestion des erreurs et vérifications
    const [erreurCarte, setErreurCarte] = useState("");
    const [erreurConducteurs, setErreurConducteurs] = useState("");
    const [erreurConfirmation, setErreurConfirmation] = useState("");
    const [verificationEnCours, setVerificationEnCours] = useState(false);
    const [verificationConducteurEnCours, setVerificationConducteurEnCours] = useState(false);
    const [miseEnFilerEnCours, setMiseEnFilerEnCours] = useState(false);

    // États pour stocker les informations vérifiées
    const [infosCamion1, setInfosCamion1] = useState(null);
    const [infosCamion2, setInfosCamion2] = useState(null);
    const [infosConducteurPrincipal, setInfosConducteurPrincipal] = useState(null);
    const [infosConducteurAssistant, setInfosConducteurAssistant] = useState(null);

    // États pour contrôler la visibilité des boutons
    const [boutonSuivantVisible, setBoutonSuivantVisible] = useState(false);
    const [boutonSuivantConducteurVisible, setBoutonSuivantConducteurVisible] = useState(false);
    const [boutonEnregistrerVisible, setBoutonEnregistrerVisible] = useState(false);


    const resetForm = () => {
        const parcReference = formData.reference_parc;
        setFormData({
            atellage: '2',
            org_pro: '',
            nom_conducteur_principal: '',
            numero_permis_principal: '',
            telephone_principal: '',
            telephone_assistant: '',
            categorie_permis_principal: '',
            date_naissance_principal: '',
            nom_conducteur_assistant: '',
            numero_permis_assistant: '',
            categorie_permis_assistant: '',
            date_naissance_assistant: '',
            reference_carte_transport_1: '',
            reference_carte_transport_2: '',
            immatriculation_camion_1: '',
            immatriculation_camion_2: '',
            expiration_carte_transport_1: '',
            expiration_carte_transport_2: '',
            charge_utile_reelle_1: '',
            charge_utile_reelle_2: '',
            type_essieu: '',
            type_essieu2: '',
            nombre_essieux1: '',
            nombre_essieux2: '',
            tuslock1: '',
            tuslock2: '',
            reference_parc: parcReference,
            reference_categorie: '',
            scope: '',
            destination: ''
        });

        setSelectedEssieu(null);
        setSelectedEssieu2(null);

        setInfosCamion1(null);
        setInfosCamion2(null);
        setInfosConducteurPrincipal(null);
        setInfosConducteurAssistant(null);
        setBoutonSuivantVisible(false);
        setBoutonSuivantConducteurVisible(false);
        setBoutonEnregistrerVisible(false);
        // setSelectedParc(null);
        setSelectedCategories(null);
        setActiveTab('camion');
        setErreurCarte("");
        setErreurConducteurs("");
        setErreurConfirmation("");
    };

    


    // Fonction pour vérifier les cartes transport via l'API backend

    const verifierCartesTransport = async () => {

        setVerificationEnCours(true);
        setErreurCarte("");
        setInfosCamion1(null);
        setInfosCamion2(null);
        setBoutonSuivantVisible(false);

        const { reference_carte_transport_1, reference_carte_transport_2, atellage, immatriculation_camion_1, immatriculation_camion_2 } = formData;

        try {
            // Vérification du camion 1 (obligatoire)
            if (!reference_carte_transport_1 && !immatriculation_camion_1) {
                setErreurCarte("Veuillez renseigner soit la carte transport, soit l'immatriculation du camion 1.");
                setVerificationEnCours(false);
                return;
            }

            // Récupérer le token d'authentification
            const token = localStorage.getItem('access_token');
            let url;

            if (immatriculation_camion_1 || immatriculation_camion_2) {
                url = 'api/verifier-immatriculation/';
            } else {
                url = 'api/verifier-carte-transport/';
            }

            // Appel à votre API backend pour vérifier le camion 1
            const response = await fetch(`${process.env.REACT_APP_HOTE}/${url}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    immatriculation: immatriculation_camion_1 || null,
                    reference_carte: reference_carte_transport_1 || null,
                    user_id: user_id,
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                setErreurCarte(errorData?.error || errorData?.message || "Erreur lors de la vérification du camion 1.");
                setVerificationEnCours(false);
                return;
            }

            const carte1Valide = await response.json();

            // Récupération de la nationalité de la carte transport
            const infosCamion1AvecNationalite = {
                ...carte1Valide.data,
                nationalite_carte_transport: carte1Valide.data.nationalite_carte_transport || []
            };

            setInfosCamion1(infosCamion1AvecNationalite);
            setFormData(prev => ({
                ...prev,
                expiration_carte_transport_1: carte1Valide.data.date_expiration || '',
                scope: carte1Valide.data.scope || ''
            }));
            console.log('carte1Valide avec nationalité : ', infosCamion1AvecNationalite);

            // Vérification du camion 2 si attelage articulé
            if (atellage === '1') {
                // Vérifier si au moins un champ est rempli pour le camion 2
                const aUnChampCamion2 = reference_carte_transport_2 || immatriculation_camion_2;

                if (!aUnChampCamion2) {
                    setErreurCarte("Pour un véhicule articulé, veuillez renseigner soit la carte transport, soit l'immatriculation du camion 2.");
                    setVerificationEnCours(false);
                    return;
                }

                // Vérifier que les deux cartes ne sont pas identiques (si les deux sont renseignées)
                if (reference_carte_transport_1 && reference_carte_transport_2 && reference_carte_transport_1 === reference_carte_transport_2) {
                    setErreurCarte("Les deux cartes transport ne doivent pas être identiques.");
                    setVerificationEnCours(false);
                    return;
                }

                // Appel à votre API backend pour vérifier le camion 2
                const response2 = await fetch(`${process.env.REACT_APP_HOTE}/${url}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        immatriculation: immatriculation_camion_2 || null,
                        reference_carte: reference_carte_transport_2 || null,
                        user_id: user_id,
                    })
                });

                if (!response2.ok) {
                    const errorData = await response2.json();
                    setErreurCarte(errorData?.error || errorData?.message || "Erreur lors de la vérification du camion 2.");
                    setVerificationEnCours(false);
                    return; // Important : sortir de la fonction si la vérification échoue
                }

                const carte2Valide = await response2.json();

                // Récupération de la nationalité de la carte transport pour le 2ème camion
                const infosCamion2AvecNationalite = {
                    ...carte2Valide.data,
                    nationalite_carte_transport: carte2Valide.data.nationalite_carte_transport || []
                };

                setFormData(prev => ({
                    ...prev,
                    expiration_carte_transport_2: carte2Valide.data.date_expiration || '',
                    scope: carte2Valide.data.scope || ''
                }));
                setInfosCamion2(infosCamion2AvecNationalite);
            }

            // Si toutes les vérifications sont réussies, activer le bouton suivant
            setVerificationEnCours(false);
            setBoutonSuivantVisible(true);

        } catch (error) {
            console.error("Erreur lors de la vérification:", error);
            setErreurCarte("Une erreur réseau s'est produite. Veuillez réessayer.");
            setVerificationEnCours(false);
        }
    };

    // Fonction pour vérifier les conducteurs via l'API backend
    const verifierConducteurs = async () => {
        setVerificationConducteurEnCours(true);
        setErreurConducteurs("");
        setInfosConducteurPrincipal(null);
        setInfosConducteurAssistant(null);
        setBoutonSuivantConducteurVisible(false);

        const c1 = formData.numero_permis_principal;
        const c2 = formData.numero_permis_assistant;
        const numero_identite = formData.numero_identite;

        try {
            if (!c1) {
                setErreurConducteurs("Le numéro de permis du conducteur principal est obligatoire.");
                setVerificationConducteurEnCours(false);
                return;
            }

            // Vérification que l'assistant a au moins une donnée
            // if (!c2 && !numero_identite) {
            //     setErreurConducteurs("L'assistant est obligatoire. Veuillez renseigner soit son numéro de permis, soit son numéro d'identification.");
            //     setVerificationConducteurEnCours(false);
            //     return;
            // }

            // Récupérer le token d'authentification
            const token = localStorage.getItem('access_token');

            // Vérification du conducteur principal
            const response = await fetch(`${process.env.REACT_APP_HOTE}/api/verifier-conducteur/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    numero_permis: c1,
                    user_id: user_id,
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                setErreurConducteurs(errorData.message || "Erreur lors de la vérification du conducteur principal.");
                setVerificationConducteurEnCours(false);
                return;
            }

            const conducteurPrincipalValide = await response.json();
            setInfosConducteurPrincipal(conducteurPrincipalValide.data);

            // Récupérer le téléphone du conducteur principal
            setFormData(prev => ({
                ...prev,
                telephone_principal: conducteurPrincipalValide.data.phone || ''
            }));

            // Vérification du conducteur assistant
            if (c2) {
                if (c1 === c2) {
                    setErreurConducteurs("Les numéros de permis des deux conducteurs doivent être différents.");
                    setVerificationConducteurEnCours(false);
                    return;
                }

                const response2 = await fetch(`${process.env.REACT_APP_HOTE}/api/verifier-conducteur/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        numero_permis: c2,
                        user_id: user_id,
                    })
                });

                if (!response2.ok) {
                    const errorData = await response2.json();
                    setErreurConducteurs(errorData.message || "Erreur lors de la vérification du conducteur assistant..");
                    setVerificationConducteurEnCours(false);
                    return;
                }

                const conducteurAssistantValide = await response2.json();
                setInfosConducteurAssistant(conducteurAssistantValide.data);

                // Récupérer le téléphone du conducteur assistant
                setFormData(prev => ({
                    ...prev,
                    telephone_assistant: conducteurAssistantValide.data.phone || ''
                }));

            } else if (numero_identite) {
                // Vérification via numéro d'identité
                const response3 = await fetch(`${process.env.REACT_APP_HOTE}/api/verifier-conducteur/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        numero_identite: numero_identite
                    })
                });

                if (!response3.ok) {
                    const errorData = await response3.json();
                    setErreurConducteurs(errorData.error || "Erreur lors de la vérification via numéro d'identité.");
                    setVerificationConducteurEnCours(false);
                    return;
                }

                const conducteurIdentiteValide = await response3.json();
                setInfosConducteurAssistant(conducteurIdentiteValide.data);

                // Récupérer le téléphone du conducteur assistant
                setFormData(prev => ({
                    ...prev,
                    telephone_assistant: conducteurIdentiteValide.data.phone || ''
                }));
            }

            // Vérifier que les deux conducteurs sont bien vérifiés avant d'afficher le bouton suivant
            if (infosConducteurPrincipal) {
                setBoutonSuivantConducteurVisible(true);
            }

            setVerificationConducteurEnCours(false);

        } catch (error) {
            console.error("Erreur lors de la vérification:", error);
            setErreurConducteurs("Une erreur réseau s'est produite. Veuillez réessayer.");
            setVerificationConducteurEnCours(false);
        }
    };

    useEffect(() => {
        // Vérifier automatiquement quand les deux conducteurs sont disponibles
        if (infosConducteurPrincipal) {
            setBoutonSuivantConducteurVisible(true);
            setErreurConducteurs("");
        } else {
            setBoutonSuivantConducteurVisible(false);
        }
    }, [infosConducteurPrincipal]);


    const validerConfirmation = () => {
        if (!formData.reference_parc) {
            setErreurConfirmation("La référence du parc est obligatoire.");
            return false;
        }

        if (!formData.reference_categorie) {
            setErreurConfirmation("La catégorie est obligatoire.");
            return false;
        }

        if (!formData.type_essieu) {
            setErreurConfirmation("Le type essieu du camion 1 est obligatoire.");
            return false;
        }

        // if (!formData.charge_utile_reelle_1) {
        //     setErreurConfirmation("La charge utile réelle du camion 1 est obligatoire.");
        //     return false;
        // }

        // Vérifier que la charge utile réelle ne dépasse pas la charge utile théorique
        const chargeTheorique1 = parseInt(infosCamion1.payload);
        const chargeReelle1 = parseInt(formData.charge_utile_reelle_1);

        // if (chargeReelle1 > chargeTheorique1) {
        //     setErreurConfirmation(`La charge utile réelle du camion 1 ne peut pas dépasser ${chargeTheorique1}`);
        //     return false;
        // }

        // if (infosCamion2 && !formData.charge_utile_reelle_2) {
        //     setErreurConfirmation("La charge utile réelle du camion 2 est obligatoire.");
        //     return false;
        // }

        if (infosCamion2 && !formData.type_essieu2) {
            setErreurConfirmation("Le type essieu du camion 2 est obligatoire.");
            return false;
        }

        // if (infosCamion2) {
        //     const chargeTheorique2 = parseInt(infosCamion2.payload);
        //     const chargeReelle2 = parseInt(formData.charge_utile_reelle_2);

        //     if (chargeReelle2 > chargeTheorique2) {
        //         setErreurConfirmation(`La charge utile réelle du camion 2 ne peut pas dépasser ${chargeTheorique2}`);
        //         return false;
        //     }
        // }

        if (!formData.nombre_essieux1) {
            setErreurConfirmation("Le nombre d'essieux du camion 1 est obligatoire.");
            return false;
        }

        if (infosCamion2 && !formData.nombre_essieux2) {
            setErreurConfirmation("Le nombre d'essieux du camion 2 est obligatoire.");
            return false;
        }


        // if (!formData.numero_permis_assistant && !formData.numero_identite) {
        //     setErreurConfirmation("Veuillez renseigner soit le numéro de permis, soit le numéro d'identité de l'assistant.");
        //     return false;
        // }

        setErreurConfirmation("");
        setBoutonEnregistrerVisible(true);
        return true;
    };

    const handleNextFromCamion = () => {
        if (!boutonSuivantVisible) {
            setErreurCarte("Veuillez d'abord vérifier les cartes transport.");
            return;
        }
        setActiveTab('conducteur');
    };

    const handleNextFromConducteur = () => {
        if (!boutonSuivantConducteurVisible) {
            setErreurConducteurs("Veuillez d'abord vérifier les conducteurs.");
            return;
        }
        setActiveTab('confirmation');
    };

    const handleBackToCamion = () => {
        setActiveTab('camion');
    };

    const handleBackToConducteur = () => {
        setActiveTab('conducteur');
    };


    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     if (validerConfirmation()) {
    //         setMiseEnFilerEnCours(true); // 🔹 Début du chargement

    //         try {
    //             const donneesCompletes = {
    //                 ...formData,
    //                 infosCamion1,
    //                 infosCamion2,
    //                 infosConducteurPrincipal,
    //                 infosConducteurAssistant,
    //                 timestamp: new Date().toISOString()
    //             };

    //             // Simulation d'un délai (par exemple si tu attends une API)
    //             await new Promise(resolve => setTimeout(resolve, 5000));

    //             onSave(donneesCompletes);
    //         } catch (error) {
    //             console.error("❌ Erreur lors de la mise en file :", error);
    //         } finally {
    //             setMiseEnFilerEnCours(false); // 🔹 Fin du chargement
    //         }
    //     }
    // };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validerConfirmation()) {
            setMiseEnFilerEnCours(true);

            try {
                const donneesCompletes = {
                    ...formData,
                    infosCamion1,
                    infosCamion2,
                    infosConducteurPrincipal,
                    infosConducteurAssistant,
                    user_id,
                    timestamp: new Date().toISOString()
                };

                // Appeler onSave et attendre le résultat
                const result = await onSave(donneesCompletes);

                // Vider le formulaire seulement si l'envoi est réussi
                resetForm();

            } catch (error) {
                console.error("❌ Erreur lors de la mise en file :", error);
            } finally {
                setMiseEnFilerEnCours(false);
            }
        }
    };


    // États initiaux du formulaire
    const [activeTab, setActiveTab] = useState('camion');
    const [formData, setFormData] = useState({
        atellage: '2',
        org_pro: '',
        nom_conducteur_principal: '',
        numero_permis_principal: '',
        categorie_permis_principal: '',
        date_naissance_principal: '',
        nom_conducteur_assistant: '',
        numero_permis_assistant: '',
        numero_identite: '',
        categorie_permis_assistant: '',
        date_naissance_assistant: '',
        reference_carte_transport_1: '',
        reference_carte_transport_2: '',
        immatriculation_camion_1: '',
        immatriculation_camion_2: '',
        charge_utile_reelle_1: '',
        charge_utile_reelle_2: '',
        type_essieu: '',
        type_essieu2: '',
        nombre_essieux1: '',
        nombre_essieux2: '',
        tuslock1: '',
        tuslock2: '',
        reference_parc: '',
        reference_categorie: '',
        destination: ''
    });

    // À ajouter après la déclaration de vos états
useEffect(() => {
    // Synchroniser selectedEssieu avec formData.type_essieu
    if (!formData.type_essieu) {
        setSelectedEssieu(null);
    }
}, [formData.type_essieu]);

useEffect(() => {
    // Synchroniser selectedEssieu2 avec formData.type_essieu2
    if (!formData.type_essieu2) {
        setSelectedEssieu2(null);
    }
}, [formData.type_essieu2]);

    const [conducteurs, setConducteurs] = useState([]);
    const [parcs, setParcs] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedConducteurPrincipal, setSelectedConducteurPrincipal] = useState(null);
    const [selectedConducteurAssistant, setSelectedConducteurAssistant] = useState(null);
    const [selectedParc, setSelectedParc] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState(null);
    const [pays, setPays] = useState([]);
    const [essieu, setEssieu] = useState([]);
    const [selectedEssieu, setSelectedEssieu] = useState(null);
    const [selectedEssieu2, setSelectedEssieu2] = useState(null);

    // Fonctions pour récupérer les données
    const fetchConducteurs = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-conducteur/");
            if (response.ok) {
                const data = await response.json();
                setConducteurs(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des conducteurs:", error);
        }
    };

    const fetchParcs = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/");
            if (response.ok) {
                const data = await response.json();
                const parcsFiltres = data.filter((parc) => parc.type_parc === typeParc);
                setParcs(parcsFiltres);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des parcs:", error);
        }
    };

    // Récupération des categories
    const fetchCategories = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-categories/");
            if (response.ok) {
                const data = await response.json();
                setCategories(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des categories:", error);
        }
    };


    const fetchPays = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-nationalites/`);
            const data = await response.json();
            const formattedCountries = data.map((country) => ({
                value: country.code_pays,
                label: country.pays,
                code: country.code_pays
            }));
            setPays(formattedCountries);
        } catch (error) {
            console.error("Erreur lors du chargement des pays :", error);
        }
    };

    // Récupération des types essieux
    const fetchEssieux = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-essieu/");
            if (response.ok) {
                const data = await response.json();
                setEssieu(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des essieux:", error);
        }
    };

    useEffect(() => {
        fetchParcs();
        fetchPays();
        fetchConducteurs();
        fetchCategories();
        fetchEssieux();
    }, []);



    const [parcPreselectionne, setParcPreselectionne] = useState(null);
    useEffect(() => {
        if (userData.parc && parcs.length > 0) {
            // Trouver le parc qui correspond au userData.parc
            const parcTrouve = parcs.find(parc =>
                parc.ref_parc === userData.parc ||
                parc.ref_parc === parcRef
            );

            if (parcTrouve) {
                const optionParc = {
                    value: parcTrouve.ref_parc,
                    label: `${parcTrouve.nom_parc} (${parcTrouve.ref_parc})`
                };

                setParcPreselectionne(optionParc);
                setSelectedParc(optionParc);

                // Pré-remplir aussi le formData
                setFormData(prev => ({
                    ...prev,
                    reference_parc: parcTrouve.ref_parc
                }));
            }
        }
    }, [userData.parc, parcs]);

    // Gestionnaires d'événements
    const handleParcChange = (selectedOption) => {
        setSelectedParc(selectedOption);
        setFormData(prev => ({
            ...prev,
            reference_parc: selectedOption ? selectedOption.value : ''
        }));
    };

    const handleCategoriesChange = (selectedOption) => {
        setSelectedCategories(selectedOption);
        setFormData(prev => ({
            ...prev,
            reference_categorie: selectedOption ? selectedOption.value : ''
        }));
    };

    const handleEssieuChange = (selectedOption) => {
        setSelectedEssieu(selectedOption);
        setFormData(prev => ({
            ...prev,
            type_essieu: selectedOption ? selectedOption.value : ''
        }));
    };

    const handleEssieuChange2 = (selectedOption) => {
        setSelectedEssieu2(selectedOption);
        setFormData(prev => ({
            ...prev,
            type_essieu2: selectedOption ? selectedOption.value : ''
        }));
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption ? selectedOption.value : ''
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Champs qui doivent être en majuscules
        const uppercaseFields = ["reference_carte_transport_1", "reference_carte_transport_2"];

        setFormData((prev) => ({
            ...prev,
            [name]: uppercaseFields.includes(name) ? value.toUpperCase() : value,
        }));
    };


    const parcOptions = parcs.map(parc => ({
        value: parc.ref_parc,
        label: `${parc.nom_parc} (${parc.ref_parc})`
    }));

    const categoriesOptions = categories.map(categorie => ({
        value: categorie.ref_categorie,
        label: `${categorie.nom_categorie} (${categorie.ref_categorie})`
    }));

    const essieuOptions = essieu.map(essieu => ({
        value: essieu.id,
        label: `${essieu.type_essieu} (${essieu.charge_max} T)`
    }));

    // Fonction pour afficher le statut avec un badge coloré
    const renderStatutBadge = (statut) => {
        let variant = 'secondary';
        if (statut === 'Valide') variant = 'success';
        if (statut === 'En maintenance') variant = 'warning';
        if (statut === 'Expiré') variant = 'danger';

        return <Badge bg={variant}>{statut}</Badge>;
    };


    const getTypeIdFromCode = (code) => {
        const type = types.find(t => t.ref === code);
        return type ? type.id : null;
    };

    // Rendu de l'onglet Camion
    const renderCamionTab = () => (
        <Card className="mb-4">
            <Card.Header>
                <h6 className="mb-0">Informations du camion</h6>
            </Card.Header>

            {erreurCarte && (
                <Alert variant="danger" className="m-3 mb-0 py-1">
                    {erreurCarte}
                </Alert>
            )}
            <Card.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Atellage <span style={{ color: 'red' }}>*</span></Form.Label>
                    <Form.Select className='custom-select' name="atellage" value={formData.atellage} onChange={handleChange}>
                        <option value="1">Articulé</option>
                        <option value="2">Non articulé</option>
                    </Form.Select>
                </Form.Group>

                {/* <Row>
                    <Col md={formData.atellage === '1' ? 6 : 12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Référence carte transport {formData.atellage === '1' && '1'} <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="reference_carte_transport_1"
                                value={formData.reference_carte_transport_1}
                                onChange={handleChange}
                                required
                                placeholder="Référence obligatoire"
                            />
                        </Form.Group>
                    </Col>
                    {formData.atellage === '1' &&
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Référence carte transport 2 <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="reference_carte_transport_2"
                                    value={formData.reference_carte_transport_2}
                                    onChange={handleChange}
                                    placeholder="Référence obligatoire"
                                />
                            </Form.Group>
                        </Col>
                    }
                </Row> */}



                <Row>
                    <Col md={12}>
                        <Card className="mb-3 border">
                            <Card.Body className="p-3">
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Référence carte transport {formData.atellage === '1' && '1'} <span style={{ color: 'red' }}>*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="reference_carte_transport_1"
                                                value={formData.reference_carte_transport_1}
                                                onChange={handleChange}
                                                required
                                                placeholder="Référence obligatoire"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Immatriculation camion {formData.atellage === '1' && '1'} </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="immatriculation_camion_1"
                                                value={formData.immatriculation_camion_1}
                                                onChange={handleChange}
                                                required
                                                placeholder="Immatriculation"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        {/* Affichage des informations des camions */}
                        {infosCamion1 && (
                            <Card className="mb-4 border-0 shadow-sm">
                                <Card.Header className="d-flex align-items-center py-2 bg-warning">
                                    {/* <FaExclamation className='mr-2'/> */}
                                    <div> <strong>IMPORTANT</strong> : Vérifiez que les données reçues de SYGFR sont conformes au véhicule présent devant vous.</div>

                                </Card.Header>

                                <Card.Body className="p-3">
                                    <Row className="g-2 mb-2">
                                        <Col md={6}>
                                            <div className="d-flex align-items-center">
                                                <strong className="me-2">Immatriculation :</strong>
                                                <span className='ml-2'> {infosCamion1.immatriculation}</span>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="d-flex align-items-center">
                                                <strong className="me-2">Chassis :</strong>
                                                <span className="text-truncate ml-2"> {infosCamion1.numero_chassis}</span>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="g-2 mb-2">
                                        <Col md={6}>
                                            <div className="d-flex align-items-center">
                                                <strong className="me-2">Pays :</strong>
                                                <span className="ml-2">{infosCamion1.pays?.name || infosCamion1.pays}</span>

                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="d-flex align-items-center">
                                                <strong className="me-2">Essieux :</strong>
                                                <span className='ml-2'> {infosCamion1.nombre_essieux}</span>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="g-2 mb-2">
                                        <Col md={6}>
                                            <div className="d-flex align-items-center">
                                                <strong className="me-2">Poids vide :</strong>
                                                <span className='ml-2'> {infosCamion1.poids_vide}</span>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="d-flex align-items-center">
                                                <strong className="me-2 ">Charge utile :</strong>
                                                <span className=" ml-2"> {infosCamion1.charge_utile}</span>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="g-2 mb-2">
                                        <Col md={6}>
                                            <div className="d-flex align-items-center">
                                                <strong className="me-2">Propriétaire :</strong>
                                                <span className="text-truncate ml-2">{infosCamion1.proprietaire}</span>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="d-flex align-items-center">
                                                <strong className="me-2">Type :</strong>
                                                <span className='ml-2'>{infosCamion1.type_vehicule.name}</span>
                                            </div>
                                        </Col>
                                    </Row>

                                    {infosCamion1.nationalite_carte_transport && infosCamion1.nationalite_carte_transport.length > 0 && (
                                        <Row className="g-2 mb-2">
                                            <Col md={12}>
                                                <div className="d-flex align-items-center">
                                                    <strong className="me-2">Pays autorisés :</strong>
                                                    <span className="ml-2">
                                                        {infosCamion1.nationalite_carte_transport
                                                            .map(pays => pays.name)
                                                            .join(', ')}
                                                    </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}

                                    {infosCamion1.bailleurs && infosCamion1.bailleurs.length > 0 && (
                                        <Row className="g-2 mb-2">
                                            <Col md={12}>
                                                <div className="d-flex align-items-start">
                                                    <strong className="me-2 mr-3">Bailleurs affiliés :</strong>
                                                    <div>
                                                        {infosCamion1.bailleurs.map((bailleur, index) => (
                                                            <div key={index} className="mb-1">
                                                                • {bailleur.name} <span className="text-muted">(IFU: {bailleur.ifu})</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}

                                    <div className="mt-2">
                                        <small className="text-muted">
                                            Statut: {infosCamion1.statut} • Expiration: {new Date(infosCamion1.date_expiration).toLocaleDateString()}
                                        </small>
                                    </div>

                                    {/* Nouvelles informations Twist Lock */}
                                    {(infosCamion1.twistLock_reference || infosCamion1.twistLock_issuanceDate || infosCamion1.twistLock_expirationDate) && (
                                        <>
                                            <hr className="my-3" />
                                            <Row className="g-2 mb-2">
                                                <Col md={12}>
                                                    <h6 className="text-primary mb-3">
                                                        <i className="fa fa-anchor mr-2"></i>
                                                        Informations Twist Lock
                                                    </h6>
                                                </Col>
                                            </Row>

                                            {infosCamion1.twistLock_reference && (
                                                <Row className="g-2 mb-2">
                                                    <Col md={6}>
                                                        <div className="d-flex align-items-center">
                                                            <strong className="me-2">Référence :</strong>
                                                            <span className='ml-2'> {infosCamion1.twistLock_reference}</span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}

                                            <Row className="g-2 mb-2">
                                                {infosCamion1.twistLock_issuanceDate && (
                                                    <Col md={6}>
                                                        <div className="d-flex align-items-center">
                                                            <strong className="me-2">Date d'émission :</strong>
                                                            <span className='ml-2'>
                                                                {new Date(infosCamion1.twistLock_issuanceDate).toLocaleDateString()}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                )}
                                                {infosCamion1.twistLock_expirationDate && (
                                                    <Col md={6}>
                                                        <div className="d-flex align-items-center">
                                                            <strong className="me-2">Date d'expiration :</strong>
                                                            <span className='ml-2'>
                                                                {new Date(infosCamion1.twistLock_expirationDate).toLocaleDateString()}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                )}
                                            </Row>
                                        </>
                                    )}
                                </Card.Body>

                            </Card>
                        )}
                    </Col>


                    {formData.atellage === '1' &&
                        <Col md={12}>
                            <Card className="mb-3 border">
                                <Card.Body className="p-3">
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Référence carte transport 2 <span style={{ color: 'red' }}>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="reference_carte_transport_2"
                                                    value={formData.reference_carte_transport_2}
                                                    onChange={handleChange}
                                                    placeholder="Référence obligatoire"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Immatriculation camion 2 </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="immatriculation_camion_2"
                                                    value={formData.immatriculation_camion_2}
                                                    onChange={handleChange}
                                                    placeholder="Immatriculation"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            {infosCamion2 && (
                                <Card className="mb-4 border-0 shadow-sm">
                                    <Card.Header className="d-flex align-items-center py-2 bg-warning">
                                        <FaExclamationCircle className='mr-2' />
                                        <div>Veuillez vérifier attentivement les données reçues de <strong>Sygfr</strong> avant de continuer.</div>

                                    </Card.Header>

                                    <Card.Body className="p-3">
                                        <Row className="g-2 mb-2">
                                            <Col md={6}>
                                                <div className="d-flex align-items-center">
                                                    <strong className="me-2">Immatriculation :</strong>
                                                    <span className='ml-2'> {infosCamion2.immatriculation}</span>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="d-flex align-items-center">
                                                    <strong className="me-2">Chassis :</strong>
                                                    <span className="text-truncate ml-2"> {infosCamion2.numero_chassis}</span>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row className="g-2 mb-2">
                                            <Col md={6}>
                                                <div className="d-flex align-items-center">
                                                    <strong className="me-2">Pays :</strong>
                                                    <span>{infosCamion2.pays?.name || infosCamion2.pays}</span>

                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="d-flex align-items-center">
                                                    <strong className="me-2">Essieux :</strong>
                                                    <span className='ml-2'> {infosCamion2.nombre_essieux}</span>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row className="g-2 mb-2">
                                            <Col md={6}>
                                                <div className="d-flex align-items-center">
                                                    <strong className="me-2">Poids vide :</strong>
                                                    <span className='ml-2'> {infosCamion2.poids_vide}</span>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="d-flex align-items-center">
                                                    <strong className="me-2 ">Charge utile :</strong>
                                                    <span className=" ml-2"> {infosCamion2.charge_utile}</span>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row className="g-2 mb-2">
                                            <Col md={6}>
                                                <div className="d-flex align-items-center">
                                                    <strong className="me-2">Propriétaire :</strong>
                                                    <span className="text-truncate ml-2">{infosCamion2.proprietaire}</span>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="d-flex align-items-center">
                                                    <strong className="me-2">Type :</strong>
                                                    <span className='ml-2'>{infosCamion2.type_vehicule.name}</span>
                                                </div>
                                            </Col>
                                        </Row>

                                        {infosCamion2.nationalite_carte_transport && infosCamion2.nationalite_carte_transport.length > 0 && (
                                            <Row className="g-2 mb-2">
                                                <Col md={12}>
                                                    <div className="d-flex align-items-center">
                                                        <strong className="me-2">Pays autorisés :</strong>
                                                        <span className="ml-2">
                                                            {infosCamion2.nationalite_carte_transport
                                                                .map(pays => pays.name)
                                                                .join(', ')}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}

                                        {infosCamion2.bailleurs && infosCamion2.bailleurs.length > 0 && (
                                            <Row className="g-2 mb-2">
                                                <Col md={12}>
                                                    <div className="d-flex align-items-center">
                                                        <strong className="me-2">Bailleurs affiliés :</strong>
                                                        <span className="ml-2">
                                                            {infosCamion2.bailleurs
                                                                .map(bailleur => bailleur.ifu)
                                                                .join(', ')}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}

                                        <div className="mt-2">
                                            <small className="text-muted">
                                                Statut: {infosCamion2.statut} • Expiration: {new Date(infosCamion2.date_expiration).toLocaleDateString()}
                                            </small>
                                        </div>

                                        {/* Nouvelles informations Twist Lock */}
                                        {(infosCamion2.twistLock_reference || infosCamion2.twistLock_issuanceDate || infosCamion2.twistLock_expirationDate) && (
                                            <>
                                                <hr className="my-3" />
                                                <Row className="g-2 mb-2">
                                                    <Col md={12}>
                                                        <h6 className="text-primary mb-3">
                                                            <i className="fa fa-anchor mr-2"></i>
                                                            Informations Twist Lock
                                                        </h6>
                                                    </Col>
                                                </Row>

                                                {infosCamion2.twistLock_reference && (
                                                    <Row className="g-2 mb-2">
                                                        <Col md={6}>
                                                            <div className="d-flex align-items-center">
                                                                <strong className="me-2">Référence :</strong>
                                                                <span className='ml-2'> {infosCamion2.twistLock_reference}</span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                )}

                                                <Row className="g-2 mb-2">
                                                    {infosCamion2.twistLock_issuanceDate && (
                                                        <Col md={6}>
                                                            <div className="d-flex align-items-center">
                                                                <strong className="me-2">Date d'émission :</strong>
                                                                <span className='ml-2'>
                                                                    {new Date(infosCamion2.twistLock_issuanceDate).toLocaleDateString()}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    {infosCamion2.twistLock_expirationDate && (
                                                        <Col md={6}>
                                                            <div className="d-flex align-items-center">
                                                                <strong className="me-2">Date d'expiration :</strong>
                                                                <span className='ml-2'>
                                                                    {new Date(infosCamion2.twistLock_expirationDate).toLocaleDateString()}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    )}
                                                </Row>
                                            </>
                                        )}
                                    </Card.Body>

                                </Card>
                            )}
                        </Col>
                    }
                </Row>

            </Card.Body>
        </Card>
    );

    // Rendu de l'onglet Conducteur
    const renderConducteurTab = () => (
        <>
            {/* Bloc Conducteur Principal */}
            <Card className="mb-4">
                <Card.Header>
                    <h6 className="mb-0">Conducteur principal <span style={{ color: 'red' }}>*</span></h6>
                </Card.Header>

                {erreurConducteurs && (
                    <Alert variant="danger" className="m-3 mb-0 py-1">
                        {erreurConducteurs}
                    </Alert>
                )}
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Numéro du permis du conducteur principal</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="numero_permis_principal"
                                    value={formData.numero_permis_principal}
                                    onChange={handleChange}
                                    required
                                    placeholder="Numéro de permis"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Affichage des informations du conducteur principal */}
                    {infosConducteurPrincipal && (
                        <Card className="mb-3">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <h6 className="mb-0">Informations du conducteur principal</h6>
                                {/* <Badge bg="info">Vérifié</Badge> */}
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col md={6}>
                                        <p><strong>Nom :</strong> {infosConducteurPrincipal.nom}</p>
                                        <p><strong>Catégorie permis :</strong> {infosConducteurPrincipal.categorie_permis}</p>
                                        <p><strong>Téléphone :</strong> {infosConducteurPrincipal.phone || 'Non renseigné'}</p>
                                        {/* <p><strong>Date de naissance :</strong> {infosConducteurPrincipal.date_naissance}</p> */}
                                    </Col>
                                    <Col md={6}>
                                        <p><strong>Statut :</strong> {infosConducteurPrincipal.statut}</p>
                                        <p><strong>Date d'expiration :</strong> {new Date(infosConducteurPrincipal.date_validite).toLocaleDateString()}</p>
                                        {infosConducteurPrincipal.nationalite && (
                                            <p><strong>Nationalité:</strong> {infosConducteurPrincipal.nationalite}</p>
                                        )}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    )}
                </Card.Body>
            </Card>

            {/* Bloc Conducteur Assistant */}
            <Card className="mb-4">
                <Card.Header>
                    <h6 className="mb-0">Conducteur assistant</h6>
                </Card.Header>
                <Card.Body>
                    {/* <Alert variant="info" className="mb-3">
                        <strong>Information :</strong> Vous devez renseigner au moins une des deux informations suivantes pour l'assistant.
                    </Alert> */}

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Numéro du permis du conducteur assistant</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="numero_permis_assistant"
                                    value={formData.numero_permis_assistant}
                                    onChange={handleChange}
                                    placeholder="Numéro du permis du conducteur l'assistant"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Numéro de la pièce d'identité de l'assistant</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="numero_identite"
                                    value={formData.numero_identite}
                                    onChange={handleChange}
                                    placeholder="Numéro de la pièce d'identité"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Message d'erreur si les deux champs sont vides */}
                    {/* {!formData.numero_permis_assistant && !formData.numero_identite && (
                        <Alert variant="warning" className="mb-3">
                            <FaExclamationTriangle className="me-2" />
                            Veuillez renseigner au moins une information pour l'assistant.
                        </Alert>
                    )} */}

                    {/* Affichage des informations du conducteur assistant */}
                    {infosConducteurAssistant && (
                        <Card className="mb-3">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <h6 className="mb-0">Informations de l'assistant</h6>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col md={6}>
                                        <p><strong>Nom :</strong> {infosConducteurAssistant.nom}</p>
                                        <p><strong>Catégorie permis :</strong> {infosConducteurAssistant.categorie_permis}</p>
                                        <p><strong>Téléphone :</strong> {infosConducteurAssistant.phone || 'Non renseigné'}</p>
                                    </Col>
                                    <Col md={6}>
                                        <p><strong>Statut :</strong> {infosConducteurAssistant.statut}</p>
                                        <p><strong>Date d'expiration :</strong> {new Date(infosConducteurAssistant.date_validite).toLocaleDateString()}</p>
                                        {infosConducteurAssistant.nationalite && (
                                            <p><strong>Nationalité :</strong> {infosConducteurAssistant.nationalite}</p>
                                        )}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    )}
                </Card.Body>
            </Card>
        </>
    );

    // Rendu de l'onglet Confirmation
    const renderConfirmationTab = () => (
        <Card className="mb-4">
            <Card.Header>
                <h6 className="mb-0">Confirmation de mise en file</h6>
            </Card.Header>

            {erreurConfirmation && (
                <Alert variant="danger" className="m-3 mb-0 py-1">
                    {erreurConfirmation}
                </Alert>
            )}

            <Card.Body>
                {/* <Alert variant="info" className="mb-4">
                    <strong>Vérification finale</strong> - Veuillez confirmer les informations ci-dessous avant la mise en file
                </Alert> */}

                {/* Section Parc et Catégorie */}
                <Row className="mb-4">

                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Référence du parc <span style={{ color: 'red' }}>*</span></Form.Label>
                            {parcPreselectionne ? (
                                <>
                                    <Form.Control
                                        type="text"
                                        value={parcPreselectionne.label}
                                        readOnly
                                        disabled
                                        className="bg-light"
                                    />
                                    <Form.Text className="text-muted">
                                        Parc attribué à votre compte
                                    </Form.Text>
                                </>
                            ) : (
                                <Select
                                    options={parcOptions}
                                    value={selectedParc}
                                    onChange={handleParcChange}
                                    placeholder="Sélectionner un parc"
                                    isClearable
                                />
                            )}
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Catégorie du fret <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Select
                                options={categoriesOptions}
                                value={selectedCategories}
                                onChange={handleCategoriesChange}
                                placeholder="Sélectionner une catégorie"
                                isClearable
                            />
                        </Form.Group>
                    </Col>
                </Row>

                {/* Section Charge Utile Réelle */}
                <Card className="mb-4">
                    <Card.Header>
                        <h6 className="mb-0">Type essieux & Nombre essieux</h6>
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Type essieu constaté {formData.atellage === '1' && 'tracteur'} <span style={{ color: 'red' }}>*</span>
                                    </Form.Label>
                                    {/* <Form.Control
                                        type="number"
                                        placeholder="Saisir la charge mesurée"
                                        value={formData.charge_utile_reelle_1 || ''}
                                        onChange={(e) => setFormData(prev => ({
                                            ...prev,
                                            charge_utile_reelle_1: e.target.value
                                        }))}
                                        required
                                        min="0"
                                        step="0"
                                    /> */}
                                    <Select
                                        options={essieuOptions}
                                        value={selectedEssieu}
                                        onChange={handleEssieuChange}
                                        placeholder="Sélectionner un type d'essieu"
                                        isClearable
                                    />
                                    {/* <Form.Text className="text-muted">
                                        Charge utile théorique: {infosCamion1?.charge_utile}
                                    </Form.Text> */}
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Nombre essieux constaté {formData.atellage === '1' && 'tracteur'} <span style={{ color: 'red' }}>*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Saisir le nombre éssieux"
                                        value={formData.nombre_essieux1 || ''}
                                        onChange={(e) => setFormData(prev => ({
                                            ...prev,
                                            nombre_essieux1: e.target.value
                                        }))}
                                        required
                                        min="0"
                                        step="0"
                                    />
                                    {/* <Form.Text className="text-muted">
                                        Charge utile théorique: {infosCamion1?.charge_utile}
                                    </Form.Text> */}
                                </Form.Group>
                            </Col>
                            {/* <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Nombre de tuslock {formData.atellage === '1' && '- Camion 1'} <span style={{ color: 'red' }}>*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Saisir le nombre de tuslock"
                                        value={formData.tuslock1 || ''}
                                        onChange={(e) => setFormData(prev => ({
                                            ...prev,
                                            tuslock1: e.target.value
                                        }))}
                                        required
                                        min="0"
                                        step="0"
                                    />
                                </Form.Group>
                            </Col> */}
                        </Row>
                        <Row>
                            {infosCamion2 && (
                                <Col md={
                                    parametres.typeCamionTwistlock.includes(
                                        getTypeIdFromCode(infosCamion2.type_vehicule?.code)
                                    ) ? 4 : 6
                                }>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            Type essieu constaté - remorque <span style={{ color: 'red' }}>*</span>
                                        </Form.Label>
                                        <Select
                                            options={essieuOptions}
                                            value={selectedEssieu2}
                                            onChange={handleEssieuChange2}
                                            placeholder="Sélectionner un type d'essieu"
                                            isClearable
                                        />
                                        {/* <Form.Control
                                            type="number"
                                            placeholder="Saisir la charge mesurée"
                                            value={formData.charge_utile_reelle_2 || ''}
                                            onChange={(e) => setFormData(prev => ({
                                                ...prev,
                                                charge_utile_reelle_2: e.target.value
                                            }))}
                                            required
                                            min="0"
                                            step="0"
                                        /> */}
                                        {/* <Form.Text className="text-muted">
                                            Charge utile théorique: {infosCamion2?.charge_utile}
                                        </Form.Text> */}
                                    </Form.Group>
                                </Col>
                            )}
                            {infosCamion2 && (
                                <Col md={
                                    parametres.typeCamionTwistlock.includes(
                                        getTypeIdFromCode(infosCamion2.type_vehicule?.code)
                                    ) ? 4 : 6
                                }>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            Nombre essieux constaté - remorque <span style={{ color: 'red' }}>*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Saisir le nombre éssieux"
                                            value={formData.nombre_essieux2 || ''}
                                            onChange={(e) => setFormData(prev => ({
                                                ...prev,
                                                nombre_essieux2: e.target.value
                                            }))}
                                            required
                                            min="0"
                                            step="0"
                                        />
                                        {/* <Form.Text className="text-muted">
                                            Charge utile théorique: {infosCamion2?.charge_utile}
                                        </Form.Text> */}
                                    </Form.Group>
                                </Col>
                            )}


                            {infosCamion2 && parametres.typeCamionTwistlock.includes(
                                getTypeIdFromCode(infosCamion2.type_vehicule?.code)
                            ) && (
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Nombre de twistlock <span style={{ color: 'red' }}>*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Saisir le nombre de twistlock"
                                                value={formData.tuslock2 || ''}
                                                onChange={(e) => setFormData(prev => ({
                                                    ...prev,
                                                    tuslock2: e.target.value
                                                }))}
                                                required
                                                min="0"
                                                step="0"
                                            />
                                        </Form.Group>
                                    </Col>
                                )}
                        </Row>
                    </Card.Body>
                </Card>


                <Card className="mb-4">
                    <Card.Header>
                        <h6 className="mb-0">Organisation professionnelle</h6>
                    </Card.Header>
                    <Card.Body>
                        <Form.Group>
                            <Form.Label>Organisation professionnelle des transporteurs :</Form.Label>
                            <Form.Control
                                type="text"
                                name="org_pro"
                                value={formData.org_pro}
                                onChange={handleChange}
                                placeholder="Organisation professionnelle des transporteurs"
                            />
                        </Form.Group>
                    </Card.Body>
                </Card>

                {/* Section Destination (si international) */}
                {/* {typeParc === 'international' && (
                    <Card className="mb-4">
                        <Card.Header>
                            <h6 className="mb-0">Destination</h6>
                        </Card.Header>
                        <Card.Body>
                            <Form.Group>
                                <Form.Label>Destination privilégiée</Form.Label>
                                <Select
                                    name="destination"
                                    options={pays}
                                    value={pays.find(option => option.value === formData.destination)}
                                    onChange={handleSelectChange}
                                    placeholder="Sélectionner un pays..."
                                    isClearable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '42px'
                                        })
                                    }}
                                />
                            </Form.Group>
                        </Card.Body>
                    </Card>
                )} */}
            </Card.Body>
        </Card>
    );

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header>
                <Modal.Title>Mise en file</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Nav variant="tabs" className="mb-4">
                        <Nav.Item>
                            <Nav.Link
                                active={activeTab === 'camion'}
                                onClick={() => setActiveTab('camion')}
                                style={{ cursor: 'pointer' }}
                            >
                                📦 Vérification Camion
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link
                                active={activeTab === 'conducteur'}
                                onClick={() => boutonSuivantVisible && setActiveTab('conducteur')}
                                style={{ cursor: boutonSuivantVisible ? 'pointer' : 'not-allowed', opacity: boutonSuivantVisible ? 1 : 0.5 }}
                            >
                                👤 Vérification Conducteurs
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link
                                active={activeTab === 'confirmation'}
                                onClick={() => boutonSuivantConducteurVisible && setActiveTab('confirmation')}
                                style={{ cursor: boutonSuivantConducteurVisible ? 'pointer' : 'not-allowed', opacity: boutonSuivantConducteurVisible ? 1 : 0.5 }}
                            >
                                ✅ Confirmation mise en file
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>

                    {activeTab === 'camion' && renderCamionTab()}
                    {activeTab === 'conducteur' && renderConducteurTab()}
                    {activeTab === 'confirmation' && renderConfirmationTab()}
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-between w-100">
                        <div>
                            {activeTab === 'conducteur' && (
                                <Button
                                    variant="outline-secondary"
                                    onClick={handleBackToCamion}
                                    className="me-2"
                                >
                                    ← Précédent
                                </Button>
                            )}
                            {activeTab === 'confirmation' && (
                                <Button
                                    variant="outline-secondary"
                                    onClick={handleBackToConducteur}
                                    className="me-2"
                                >
                                    ← Précédent
                                </Button>
                            )}
                        </div>

                        <div>
                            {activeTab === 'camion' ? (
                                <div className="d-flex align-items-center">
                                    <Button
                                        variant="outline-primary"
                                        onClick={verifierCartesTransport}
                                        disabled={verificationEnCours}
                                        className="mr-2"
                                    >
                                        {verificationEnCours ? (
                                            <>
                                                <Spinner animation="border" size="sm" className="me-2" />
                                                Vérification...
                                            </>
                                        ) : (
                                            "Vérifier les cartes"
                                        )}
                                    </Button>
                                    {boutonSuivantVisible && (
                                        <Button variant="success" onClick={handleNextFromCamion}>
                                            Suivant →
                                        </Button>
                                    )}
                                </div>
                            ) : activeTab === 'conducteur' ? (
                                <div className="d-flex align-items-center">
                                    <Button
                                        variant="outline-primary"
                                        onClick={verifierConducteurs}
                                        disabled={verificationConducteurEnCours}
                                        className="mr-2"
                                    >
                                        {verificationConducteurEnCours ? (
                                            <>
                                                <Spinner animation="border" size="sm" className="me-2" />
                                                Vérification...
                                            </>
                                        ) : (
                                            "Vérifier les conducteurs"
                                        )}
                                    </Button>

                                    {boutonSuivantConducteurVisible && infosConducteurPrincipal ? (
                                        <Button variant="success" onClick={handleNextFromConducteur}>
                                            Suivant →
                                        </Button>
                                    ) : (
                                        <Button variant="secondary" disabled>
                                            Suivant →
                                        </Button>
                                    )}
                                </div>
                            ) : (
                                <Button variant="success" type="submit" disabled={miseEnFilerEnCours}>
                                    {miseEnFilerEnCours ? (
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            /> Chargement...
                                        </>
                                    ) : (
                                        "Confirmer la mise en file"
                                    )}
                                </Button>

                            )}
                        </div>
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default EntrerModal;